<div class="sections">
  <section *ngIf="subscriber.shippingAddress as address">
    <span>
      <ng-container i18n="@@Delivery.ShippingTo">Shipping to</ng-container>
      :
    </span>
    {{ address | shopAddress }}
  </section>
  <section>
    <span>
      <ng-container i18n="@@Common.Name">Name</ng-container>
      :
    </span>
    {{ subscriber.variantName }}
  </section>
  <section>
    <span>
      <ng-container i18n="@@Time.Interval">Interval</ng-container>
      :
    </span>
    <span class="interval">
      {{ 'SubscriptionRunIntervalBilling.' + subscriber.variantInterval | l }}
    </span>
  </section>
  <section class="footer" *xResponsiveIf="{ min: 'LG' }">
    <ng-content select="[xAction]"></ng-content>
  </section>
</div>
